module.exports = __webpack_public_path__ + "img/route_adv_1.36f97c18.png";